import React, { useEffect, useState } from 'react';
import { api } from './api';
import { Ikon } from './Ikon';

export function TimelineModal({ urun, onClose, tarihFormat }) {
  const [islemler, setIslemler] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);

  useEffect(() => {
    if (!urun) return;
    setYukleniyor(true);
    api.get(`/api/urunler/${urun.id}/islemler`)
      .then(setIslemler)
      .catch((err) => console.error(err))
      .finally(() => setYukleniyor(false));
  }, [urun]);

  if (!urun) return null;

  return (
    <div className="modal-arkaplan" onClick={onClose}>
      <div className="modal timeline-modal-ic" onClick={e => e.stopPropagation()}>
        <div className="modal-baslik">
          <h2><Ikon ad="zaman" boyut={20} /> Ürün Zaman Çizelgesi</h2>
          <button className="kapat-btn" onClick={onClose}><Ikon ad="kapat" boyut={15} /></button>
        </div>

        <div className="timeline-urun-baslik">
          <div>
            <div className="timeline-urun-ad">{urun.ad}</div>
            <div className="timeline-urun-detay">
              Kategori: <strong>{urun.kategori_ad || 'Genel'}</strong> | Birim: <strong>{urun.birim}</strong> | Kritik: <strong>{urun.kritik_seviye} {urun.birim}</strong>
            </div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '1.4rem', fontWeight: 700, color: urun.miktar <= urun.kritik_seviye ? 'var(--kritik)' : 'var(--metin)' }}>
              {urun.miktar} <span style={{ fontSize: '0.8rem', color: 'var(--soluk)' }}>{urun.birim}</span>
            </div>
          </div>
        </div>

        {yukleniyor ? (
          <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--soluk)' }}>Zaman çizelgesi yükleniyor...</div>
        ) : islemler.length === 0 ? (
          <div className="bos-durum">Bu ürüne ait henüz işlem geçmişi yok.</div>
        ) : (
          <div className="timeline-akıs">
            {islemler.map(item => (
              <div key={item.id} className="timeline-oge">
                <div className={`timeline-dunum ${item.tip}`}>
                  {item.tip === 'giris' ? '+' : '-'}
                </div>
                <div className="timeline-icerik-kart">
                  <div className="timeline-ust-satir">
                    <span className={`timeline-islem-tipi ${item.tip}`}>
                      {item.tip === 'giris' ? 'Stok Girişi' : 'Stok Çıkışı'} (+{item.tip === 'giris' ? item.miktar : -item.miktar} {urun.birim})
                    </span>
                    <span className="timeline-tarih">{tarihFormat(item.tarih)}</span>
                  </div>
                  <div className="timeline-detay-satir">
                    <span>İşlemi Yapan: <strong>{item.kullanici_ad}</strong></span>
                    {item.fatura_yolu && (
                      <button className="fatura-mini-btn" onClick={() => window.open(api.staticUrl(item.fatura_yolu))}>
                        <Ikon ad="belge" boyut={13} /> Fatura
                      </button>
                    )}
                  </div>
                  {item.not_ && <div className="timeline-not">"{item.not_}"</div>}
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="modal-alt">
          <button className="btn btn-gri" onClick={onClose}>Kapat</button>
        </div>
      </div>
    </div>
  );
}
